module.exports = __webpack_public_path__ + "img/MMV-100_1.456c4b46.png";